(() => {
  const root = document.querySelector('[data-lumen-teaser]');
  if (!root) return;

  const iso = root.getAttribute('data-countdown');
  let target = Date.parse(iso);
  if (Number.isNaN(target)) target = Date.parse('2026-09-30T10:00:00+09:00');

  const pad = (n, width) => String(Math.max(0, n)).padStart(width, '0');

  const tick = () => {
    const diff = Math.max(0, target - Date.now());
    let total = Math.floor(diff / 1000);
    const days = Math.floor(total / 86400);
    total %= 86400;
    const hours = Math.floor(total / 3600);
    total %= 3600;
    const minutes = Math.floor(total / 60);
    const seconds = total % 60;

    root.querySelectorAll('[data-lumen-unit]').forEach((el) => {
      const unit = el.getAttribute('data-lumen-unit');
      if (unit === 'days') el.textContent = pad(days, 3);
      if (unit === 'hours') el.textContent = pad(hours, 2);
      if (unit === 'minutes') el.textContent = pad(minutes, 2);
      if (unit === 'seconds') el.textContent = pad(seconds, 2);
    });

    root.querySelectorAll('[data-lumen-remain-days]').forEach((el) => {
      el.textContent = String(days);
    });

    const floatLabel = `${pad(days, 2)}:${pad(hours, 2)}:${pad(minutes, 2)}:${pad(seconds, 2)}`;
    root.querySelectorAll('[data-lumen-float-time]').forEach((el) => {
      el.textContent = floatLabel;
    });
  };

  tick();
  setInterval(tick, 1000);
})();
